<circle-progress
  [percent]="progressValue"
  [radius]="50"
  [outerStrokeWidth]="15"
  [innerStrokeWidth]="0"
  [outerStrokeColor]="getColor()"
  [animation]="true"
  [animationDuration]="300"
  [showTitle]="true"
  [titleFontSize]="'150'"
  [titleFontWeight]="'bold'"
  [showSubtitle]="false"
  [showUnits]="true"
  units="%"
>
</circle-progress>
